import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { FormControl, TextField, Tooltip, Button } from "@mui/material";
import React from "react";

import { language } from "../../../language";
import {
  getUnitPropertie,
  getPropertie,
} from "../../smart/camunda/forms/functions";

export default function OnblurComponent(props) {
  const {
    handleDefaultValueType,
    addRowDefaultValueOnBlurApi,
    handleDefaultValueChangeOnBlurApi,
    deleteDefaultValueRowOnBlurApi,
    state,
  } = props;

  const onBlurapi = getUnitPropertie(state, "onBlur_api");
  const onBlurapiProp = getPropertie(state?.properties, "onBlur_api");

  return (
    <React.Fragment>
      <FormControl fullWidth>
        <Tooltip title={language.toolTipOnBlurapi} placement="right">
          <TextField
            onChange={(event) => handleDefaultValueType(event)}
            name="onBlur_api"
            variant="outlined"
            id="onBlur_api"
            label={language.propertieOnBlurApi}
            value={onBlurapi}
          />
        </Tooltip>
      </FormControl>
      {onBlurapi && (
        <React.Fragment>
          <Button
            variant="contained"
            color="primary"
            id="onBlur_api"
            onClick={() => addRowDefaultValueOnBlurApi("onBlur_api")}
            startIcon={<AddIcon />}
          >
            {language.addNewOnblur}
          </Button>
          <table id="table" className="table table-hover">
            <thead>
              <tr>
                <th>{language.apifield}</th>
                <th>{language.smartField}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {onBlurapiProp &&
                onBlurapiProp.mapFields &&
                onBlurapiProp.mapFields.map((item, index) => {
                  return (
                    <tr key={`tr_${index}`}>
                      <td>
                        <input
                          name="api"
                          value={onBlurapiProp.mapFields[index].api}
                          onChange={(event) =>
                            handleDefaultValueChangeOnBlurApi(
                              event,
                              index,
                              "onBlur_api",
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          name="smart"
                          value={onBlurapiProp.mapFields[index].smart}
                          onChange={(event) =>
                            handleDefaultValueChangeOnBlurApi(
                              event,
                              index,
                              "onBlur_api",
                            )
                          }
                        />
                      </td>
                      <td>
                        <DeleteIcon
                          onClick={() =>
                            deleteDefaultValueRowOnBlurApi(index, "onBlur_api")
                          }
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
